<script lang="ts" setup>
import { ParagraphTextSidebar } from '~/api/graphql/generated'

defineProps<{
  entity: ParagraphTextSidebar
}>()
</script>

<template>
  <TextSidebar :text="entity.fieldText?.processed ?? ''" />
</template>
